module.exports = __webpack_public_path__ + "static/forms-multiple-fields-next-do-354804fcbde7cf48bf7a92f11bc339ac.png";